import { Node, mergeAttributes } from '@tiptap/core'

// Friendly labels for the tokens an admin can place. The key is the raw token
// name (the `{{name}}` markers the backend substitutes/validates); the value is
// the chip label shown in the WYSIWYG. Block tokens get a ▦ prefix to read as
// "a block goes here"; value tokens read as plain inline values.
export const TOKEN_LABELS = {
  // Main-document block + snippet tokens
  pool_options:       '▦ Pool options',
  pool_prices:        '▦ Pool prices',
  inclusions_block:   '▦ Inclusions',
  installer_callout:  '▦ Installer callout',
  delivery_block:     '▦ Delivery details',
  how_it_works_image: '▦ How-it-works image',
  // Interpolation tokens (main document)
  first_name:         'First name',
  sender:             'Sender',
  // Dynamic-block field value tokens
  delivery_location:   'Delivery location',
  delivery_fee:        'Delivery fee',
  pilot_phrase:        'Pilot car phrase',
  shell_or_kit:        'Shell / Kit',
  shell_or_kit_phrase: 'shell/kit wording',
  pool_name:           'Pool name',
  pool_dims:           'Pool dimensions',
  pool_size:           'Pool size',
  pool_price:          'Pool price',
  pool_link:           'Pool link',
  full_details_link:   'Full-details link',
  installer_name:      'Installer name',
  installer_phone:     'Installer phone',
}

export function tokenLabel(name) {
  return TOKEN_LABELS[name] || `{{${name}}}`
}

// A non-editable inline atom representing one `{{token}}` marker. It renders as a
// chip in the editor and round-trips LOSSLESSLY to/from the literal `{{token}}`
// text: parseHTML reads the `data-token` attribute off a `<span data-token>` and
// the serializer (see token_serialize.js) turns the node back into `{{name}}`.
export const Token = Node.create({
  name: 'token',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-token'),
        renderHTML: (attrs) => (attrs.name ? { 'data-token': attrs.name } : {}),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-token]' }]
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-token': node.attrs.name,
        class: 'email-token-chip',
        contenteditable: 'false',
      }),
      tokenLabel(node.attrs.name),
    ]
  },

  // Render the literal {{name}} when TipTap serialises to plain text (used as a
  // belt-and-braces fallback; the authoritative save path is serializeDoc).
  renderText({ node }) {
    return `{{${node.attrs.name}}}`
  },
})
